<template>
  <v-app v-if="$te('page')">
    <v-app-bar
      :color="
        this.$router.currentRoute.matched.some(({ name }) =>
          this.$store.state.coloredHeader.includes(name)
        )
          ? 'appshell'
          : 'appshell'
      "
      app
      dense
      flat
      hide-on-scroll
      prominent
      elevation="1"
    >
      <a
        href="https://www.amcham.de"
        class="d-flex my-auto align-center"
        target="_blank"
        style="margin-left: 14px"
      >
        <v-img
          class="shrink mr-2"
          contain
          :src="require('_shared/assets/logo.png')"
          transition="fade-transition"
          width="180"
        />
      </a>

      <div />
      <div class="ml-8 div-100y v-toolbar__content d-flex align-center" v-if="$router.currentRoute.matched.some(({ name })=> name=='Live')">
        <v-badge :content="UserCount">
          <v-icon>mdi-account-multiple-plus-outline</v-icon>
        </v-badge>
      </div>
      <v-spacer></v-spacer>

      <ToolbarUser class="my-auto" />

      <ToolbarLanguage
        v-if="this.$store.getters['i18n/Languages'].length > 1"
      />
    </v-app-bar>

    <v-main>
      <ConsentView />
      <router-view />
    </v-main>

    <v-footer color="secondary">
      <FooterView :light="false" :useCredits="false" />
    </v-footer>
  </v-app>
</template>

<script>
/*eslint-disable vue/no-unused-components*/
import ToolbarUser from "_shared/account/components/ToolbarUser";
import FooterView from "_shared/Footer/FooterView.vue";
import Banner from "_shared/components/Banner";
import ToolbarLanguage from "_shared/i18n/components/ToolbarLanguage";

import ConsentView from "_shared/components/ConsentView";
import {mapGetters} from 'vuex'

export default {
  name: "App",
  components: {
    ToolbarUser,
    FooterView,
    Banner,
    ToolbarLanguage,
    ConsentView,
  },

  data: () => ({
    home: "",
    dialog: false,
    type: "",
  }),
  computed:{
    ...mapGetters('userwatcher',['UserCount'])
  },
  async created() {
    this.home = (
      await window.axios.get("api/webapp/config?key=config.home")
    ).data.value;    
  },
};
</script>

<style lang="scss">
.component-header {
  margin-top: 0px;
  margin-bottom: 0px;
  line-height: 3rem;
  width: 100%;
  text-align: center;

  //color:var(--v-primary-base);
}
</style>
